import immerHandleActions from 'redux/utils/immerHandleActions';
import { layoutDirection } from 'utils/layout/rtl';
import { setLanguage } from './actions';
import Cookies from 'js-cookie';

interface setLanguageAction extends types.redux.settings.setLanguageAction {}

const languageCookie = 'com.ibm.wps.state.preprocessors.locale.LanguageCookie';

const reducers = {
	[setLanguage](state: string, action: setLanguageAction) {
		const language = action.payload;
		state = language;

		Cookies.set(languageCookie, language, { secure: true, domain: '.omantel.om' });
		document.body.dir = layoutDirection(language);

		return state;
	},
	'persist/REHYDRATE': (state: string, { payload = {} }) => {
		// @ts-ignore
		const { settings = {} } = payload;
		let { language = 'en' } = settings;
		const cookieLang = Cookies.get(languageCookie);
		if (cookieLang) {
			language = cookieLang;
		} else {
			Cookies.set(languageCookie, language, { secure: true, domain: '.omantel.om' });
		}
		if (document) document.body.dir = layoutDirection(language);

		return language;
	},
};

const init = 'EN';

export default immerHandleActions(reducers, init);
